import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface SearchBarContainerComponentProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: JSX.Element
}

const SearchBarContainerComponent = memo(({templating, children}: SearchBarContainerComponentProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName>{children}</ComponentName>
        </Suspense>
    )
})
SearchBarContainerComponent.displayName = "SearchBarContainerComponent"

export default connect(SearchBarContainerComponent)
